import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppVersion } from 'app/model/manage-versions/AppVersion';
import { CategoryDescription } from 'app/model/manage-versions/CategoryDescription';
import { CategoryEnum } from 'app/model/manage-versions/CategoryEnum';
import { AppsService } from 'app/service/apps/apps.service';

@Component({
  selector: 'aca-versions-info-modal',
  templateUrl: './versions-info-modal.component.html',
  styleUrls: ['./versions-info-modal.component.scss']
})
export class VersionsInfoModalComponent implements OnInit {
  lastVersion: AppVersion;
  loading = true;

  bugs: CategoryDescription[] = [];
  melhorias: CategoryDescription[] = [];
  novasFuncionalidades: CategoryDescription[] = [];
  appImage: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: AppVersion[],
    private appVersionService: AppsService,
    private sanitizer: DomSanitizer
  ) {
    //  usa a função reduce() para encontrar o objeto com a maior versão
    this.lastVersion = data.reduce((prev, current) => {
      // extrai as propriedades de versão dos objetos
      const highestVersion = prev.newVersion;
      const currentVersion = current.newVersion;

      // usa a função localeCompare() para comparar as versões
      return currentVersion.localeCompare(highestVersion) > 0 ? current : prev;
    });

    this.bugs = [];
    this.melhorias = [];
    this.novasFuncionalidades = [];

    this.lastVersion.categoryDescriptions.forEach((detail) => {
      switch (detail.category) {
        case CategoryEnum.CORRECAO_DE_BUG:
          this.bugs.push(detail);
          break;
        case CategoryEnum.MELHORIA:
          this.melhorias.push(detail);
          break;
        case CategoryEnum.NOVA_FUNCIONALIDADE:
          this.novasFuncionalidades.push(detail);
          break;
        default:
          break;
      }
    });
  }
  ngOnInit(): void {
    this.getImage();
  }

  getImage() {
    this.appVersionService.getNodeContent(this.lastVersion.application.imageId).subscribe((res) => {
      this.loading = false;
      const url = URL.createObjectURL(res);
      this.appImage = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }, (err) => {
      this.loading = false;
      console.error(err);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/versions/versions-info-modal/versions-info-modal.component.ts